import { Order } from '@cemex-core/cmx-api';
import { State } from '@cemex/cmx-client-layout';
import { Store } from '@ngrx/store';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { OneClickUpdateOrderAction } from '../../actions/one-click-orders.actions';
import { getOneClickContractsAvailable } from '../../selectors/one-click-contract.selector';
import { getOneClickOrders, getOneClickSelectedOrder } from '../../selectors/one-click-orders.selector';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';

export function setContractPaymentInOrder(value, store: Store<State>, index: number) {
  store
    .select(getOneClickContractsAvailable(index))
    .pipe(
      filter((contracts) => _safe(() => !!contracts.length)),
      take(1),
      map((contracts) => contracts.find((item) => item.salesDocumentItemId === value)),
      switchMap((contract) =>
        store.select(getOneClickSelectedOrder).pipe(
          take(1),
          map((order) => ({ order, contract })),
        ),
      ),
      switchMap(({ order, contract }) =>
        store.select(getOneClickOrders).pipe(
          take(1),
          map((orders) => {
            const fallbackOrder = orders.find((fall) => fall.orderId === order.orderId);
            return { order, contract, fallbackOrder };
          }),
        ),
      ),
    )
    .subscribe(({ order, contract, fallbackOrder }) => {
      const modded: Order = {
        ...order,
        items: order.items.map((item, i) => {
          if (i === index) {
            if (contract && contract.paymentTerm && contract.paymentTerm.checkPaymentTerm) {
              return {
                ...item,
                paymentTerm: { ...item.paymentTerm, paymentTermId: contract.paymentTerm.paymentTermId },
              };
            } else {
              return {
                ...item,
                paymentTerm: { ...fallbackOrder.items[index].paymentTerm },
              };
            }
          } else {
            return item;
          }
        }),
      };

      store.dispatch(new OneClickUpdateOrderAction(modded));
    });
}
